import store from '../../../helpers/store';
import Logger from '../../../../common/logger';
import { APISubmode } from '../../../api/types';

export const getConfigForTarget = (target, config) => {
    if (!config) {
        const state = store.getState();
        config = state.config.widget.questionnaireOptions;
    }

    if (!config) {
        return null;
    }

    let cfg = null;
    if (Array.isArray(config)) {
        const c = config.find((x) => x.target === target);
        if (c) {
            cfg = c.value;
            Logger.log(`Config.getForTarget [target=${c.target},qName=${cfg.questionnaireName}]`);
        } else {
            Logger.warn(`Config.getForTarget: not found [target=${target}]`);
        }
    } else {
        if (target === 'agent') {
            cfg = config;
            Logger.log(`Config.getForTarget [target=${target},qName=${cfg.questionnaireName}]`);
        } else {
            Logger.warn(`Config.getForTarget: not found [target=${target}]`);
        }
    }
    return cfg;
};

export const getConfig = (viewConfig) => {
    const getTarget = () => {
        let target = 'agent';
        const state = store.getState();
        if (state.chat && state.chat.mode) {
            switch (state.chat.mode) {
                case 'chat_bot':
                case 'bot':
                    target = 'bot';
                    break;
                default:
                    target = 'agent';
                    break;
            }
        }
        if (target === 'agent' && state.chat.submode && state.chat.submode === APISubmode.MAX) {
            target = 'bot';
        }
        return target;
    };
    const target = getTarget();

    return getConfigForTarget(target, viewConfig);
};
